export const DINAS_PENETAPAN_TAHUNAN_GURU_ENABLED = true
